export const ChecksumTableCell = ({ rowObj, clmName, clmObj }) => {
	const value = rowObj[clmName];
	const modelName = rowObj.model_name;

	let text = "";

	const style = {
		textAlign: clmObj.cellHorAlign,
		width: clmObj.width,
		maxWidth: clmObj.width,
		minWidth: clmObj.minWidth,
	};

	if (modelName === "RealObject") {
		if (value === true) {
			text = "Совпадает";
			style.backgroundColor = "var(--light-selecting-green)";
		} else if (value === false) {
			text = "Не совпадает";
			style.backgroundColor = "var(--error-cell-icon-color)";
		} else {
			text = "Отсутствует";
			style.backgroundColor = "#8080801f";
		}
	}

	return (
		<td key={`cell-${clmName}-${rowObj.id}`} className="TableCell" clm={clmName} treecell="false" title={text} style={style}>
			{text}
		</td>
	);
};
